export default __webpack_public_path__ + "static/media/info-label-desktop.3dfc1538.png";